import React from 'react';
import { Button, Checkbox, Drawer, Flex, Space } from 'antd';
import { PlusOutlined } from '@ant-design/icons';

const Mobile = ({ viewModel, disabled, buttonText }) => (
  <>
    <Button onClick={viewModel.openSheet} disabled={disabled}>
      {buttonText}
    </Button>

    <Drawer
      title='Chọn thuộc tính'
      placement='bottom'
      open={viewModel.open}
      onClose={viewModel.closeSheet}
      height='75vh'
      extra={
        <Button type='link' icon={<PlusOutlined />} loading={viewModel.creating} onClick={viewModel.createNewAttribute}>
          Thêm mới
        </Button>
      }
      footer={
        <Flex justify='flex-end' gap={8}>
          <Button onClick={viewModel.closeSheet}>Đóng</Button>
          <Button type='primary' onClick={viewModel.apply}>Xác nhận</Button>
        </Flex>
      }
    >
      <Space direction='vertical' size={8} style={{ width: '100%' }}>
        {viewModel.optionDefs.map((opt) => (
          <Checkbox
            key={opt.id}
            checked={viewModel.selectedIds.includes(String(opt.id))}
            disabled={!viewModel.selectedIds.includes(String(opt.id)) && viewModel.selectedIds.length >= 2}
            onChange={(e) => viewModel.onToggleAttribute(opt.id, e.target.checked)}
          >
            {opt.title}
          </Checkbox>
        ))}
      </Space>
    </Drawer>
  </>
);

export default Mobile;
